import script from "./GameType.vue?vue&type=script&setup=true&lang=js"
export * from "./GameType.vue?vue&type=script&setup=true&lang=js"

import "./GameType.vue?vue&type=style&index=0&id=65e1eabb&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e1eabb"]])

export default __exports__